module.exports = __webpack_public_path__ + "static/media/4.83ccc596.jpg";